import { Box } from '@mui/material'
import { AlertType } from 'src/components/shared/ui/AlertDialog/enums'
import { AlertStyles as styles } from '../AlertStyles'

interface AlertIconTitleProps {
  type: AlertType
  title: string
}
export default function AlertTitle(props: AlertIconTitleProps): JSX.Element {
  const { title, type } = props

  return <Box sx={styles(type).title}>{title}</Box>
}
